import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkTableModule } from '@angular/cdk/table';
import { ColumnDefDirective } from './directives/column-def.directive';
import { HeaderCellDefDirective } from './directives/header-cell-def.directive';
import { CellDefDirective } from './directives/cell-def.directive';
import { HeaderRowDefDirective } from './directives/header-row-def.directive';
import { RowDefDirective } from './directives/row-def.directive';
import { CellDirective } from './directives/cell.directive';
import { HeaderCellDirective } from './directives/header-cell.directive';
import { RowComponent } from './components/row/row.component';
import { TableComponent } from './components/table/table.component';
import { SortHeaderComponent } from './components/sort-header/sort-header.component';

@NgModule({
  imports: [
    CommonModule,
    CdkTableModule
  ],
  declarations: [
    ColumnDefDirective,
    HeaderCellDefDirective,
    CellDefDirective,
    HeaderRowDefDirective,
    RowDefDirective,
    CellDirective,
    HeaderCellDirective,
    RowComponent,
    TableComponent,
    SortHeaderComponent
  ],
  exports: [
    ColumnDefDirective,
    HeaderCellDefDirective,
    CellDefDirective,
    HeaderRowDefDirective,
    RowDefDirective,
    CellDirective,
    HeaderCellDirective,
    RowComponent,
    TableComponent,
    SortHeaderComponent
  ]
})
export class McRAITableModule { }
